import React from 'react';
import cx from 'classnames';
import s from './InfoSectionDescription.scss';
import {ProvidedGlobalProps, withGlobalProps} from '../../../../providers/globalPropsProvider';
import {SanitizeInnerHTMLWrapper} from '@wix/wixstores-client-common-components/dist/es/src/SanitizeInnerHTMLWrapper';
import {SPECS} from '../../../../specs';

export enum InfoSectionDescriptionDataHook {
  Description = 'info-section-description',
}
export interface InfoSectionDescriptionProps extends ProvidedGlobalProps {
  description: string;
  index: number;
}

export const InfoSectionDescription: React.FC<InfoSectionDescriptionProps> = withGlobalProps(
  (props: InfoSectionDescriptionProps) => {
    const {description, index} = props;
    const alignFontSize = props.globals.useExperiments.enabled(SPECS.PPAlignFontSizeToModernLayout);

    return (
      <SanitizeInnerHTMLWrapper innerHtml={description}>
        <div
          key={index}
          data-hook={InfoSectionDescriptionDataHook.Description}
          className={cx(s.description, {[s.alignFontSize]: alignFontSize})}
        />
      </SanitizeInnerHTMLWrapper>
    );
  }
);
